<template>
    <div class="card">
        <div class="card-header">
            <h3>Payment Method</h3>
        </div>
        <div class="card-body">
            <div class="payment" v-if="payment">
                <div class="payment__name">
                    <img :src="payment.icon" alt="Payment Method Logotype" />
                    {{ payment.name }} ending in
                    <span
                        class="payment-hidden"
                        :data-mask="createMask(payment.ending)"
                        >{{ payment.ending }}</span
                    >
                </div>
                <div>
                    Expires
                    <span
                        class="payment-hidden"
                        :data-mask="createMask(payment.expire)"
                        >{{ payment.expire }}</span
                    >
                </div>
                <div v-if="payment.address">{{ payment.address }}</div>
                <button
                    class="btn btn-sm btn-primary"
                    @click="updateModal = true"
                >
                    {{ payment ? "Update" : "Set" }} Payment
                </button>
            </div>
            <div v-else>
                <a class="btn btn-sm btn-primary" href="/payment/cards"
                    >Subscribe</a
                >
            </div>
        </div>
        <account-payment-modal
            v-if="updateModal"
            @close="updateModal = false"
        />
    </div>
</template>

<script>
import AccountPaymentModal from "./account-payment-modal.vue";
export default {
    components: { AccountPaymentModal },
    name: "account-payment",
    data() {
        return {
            updateModal: false,
        };
    },
    methods: {
        createMask(input) {
            if (input) {
                return input.replace(/\d/gi, "•");
            }
            return "";
        },
    },
    props: ["payment"],
    // computed: {
    //   payment() {
    //     const account = this.$store.getters.account
    //     if (
    //       account &&
    //       account.payment_method &&
    //       !Array.isArray(account.payment_method)
    //     ) {
    //       return account.payment_method
    //     }
    //     return false
    //   }
    // }
};
</script>

<style lang="scss">
.payment {
    font-size: 18px;
    & > * {
        margin-bottom: 1rem;
        &:last-child {
            margin-bottom: 0;
        }
    }
    &__name {
        img {
            width: 40px;
            height: 20px;
            margin-right: 0.5em;
            object-fit: contain;
            object-position: center;
        }
    }
    .payment-hidden {
        position: relative;
        display: inline-block;
        padding-right: 2px;
        padding-left: 2px;
        color: transparent;
        font-family: monospace;
        background: $gray-300;
        border-radius: 4px;
        transition: 0.2s;
        user-select: none;
        &:after {
            position: absolute;
            top: 0;
            left: 2px;
            color: $gray-600;
            transition: 0.2s;
            content: attr(data-mask);
        }
        &:hover {
            color: inherit;
            background-color: transparent;
            &:after {
                visibility: hidden;
                opacity: 0;
            }
        }
    }
}
</style>
